define.alias("shared/components/shared/media-items/post-card", "settings/components/shared/media-items/post-card");